var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.99 488.99",
    style: {
      enableBackground: "new 0 0 488.99 488.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.241,31.418h-303.03c-4.279,0-7.749,3.469-7.749,7.748v30.993H30.993c-4.279,0-7.749,3.469-7.749,7.748v38.741H7.748         c-4.279,0-7.748,3.469-7.748,7.748v309.932c0,12.817,10.427,23.245,23.245,23.245h441.654c0.104,0,0.207-0.002,0.31-0.006         c0.178,0.004,0.357,0.006,0.536,0.006c12.817,0,23.245-10.427,23.245-23.245V39.166C488.989,34.887,485.52,31.418,481.241,31.418         z M23.245,442.077c-4.273,0-7.748-3.476-7.748-7.748V132.145h426.178l0.824,302.184c0,2.715,0.468,5.324,1.328,7.748H23.245z          M473.492,434.329c0,4.273-3.475,7.748-7.748,7.748s-7.748-3.476-7.748-7.769l-0.846-309.932         c-0.012-4.271-3.477-7.727-7.749-7.727H38.742V85.655h139.469c4.279,0,7.748-3.469,7.748-7.749V46.915h287.533V434.329z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.204,85.655h240.197c4.279,0,7.749-3.469,7.749-7.749c0-4.279-3.469-7.748-7.749-7.748H209.204         c-4.279,0-7.748,3.469-7.748,7.748C201.456,82.187,204.925,85.655,209.204,85.655z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.681,240.621h-69.735v-54.238c0-4.279-3.469-7.749-7.749-7.749H54.238c-4.279,0-7.748,3.469-7.748,7.749v92.98         c0,4.279,3.469,7.749,7.748,7.749h108.477v54.238c0,4.279,3.469,7.748,7.748,7.748h147.218c4.279,0,7.748-3.469,7.748-7.748         v-92.98C325.429,244.09,321.96,240.621,317.681,240.621z M61.986,271.614v-77.482h170.463v77.482H61.986z M309.932,333.601         H178.211v-46.489h61.986c4.279,0,7.749-3.469,7.749-7.749v-23.245h61.986V333.601z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.204,209.627H85.231c-4.279,0-7.749,3.469-7.749,7.749c0,4.28,3.47,7.749,7.749,7.749h123.973         c4.279,0,7.749-3.469,7.749-7.749C216.953,213.096,213.484,209.627,209.204,209.627z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.204,240.621H85.231c-4.279,0-7.749,3.469-7.749,7.749c0,4.279,3.469,7.749,7.749,7.749h123.973         c4.28-0.001,7.749-3.47,7.749-7.749C216.953,244.091,213.484,240.621,209.204,240.621z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.66,155.39h-46.49c-4.279,0-7.749,3.469-7.749,7.748c0,4.28,3.469,7.749,7.749,7.749h46.49         c4.279,0,7.749-3.469,7.749-7.749C418.409,158.859,414.939,155.39,410.66,155.39z",
    fill: "#0D2548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.66,186.384h-46.49c-4.279,0-7.749,3.469-7.749,7.749c0,4.279,3.469,7.749,7.749,7.749h46.49         c4.279,0,7.749-3.469,7.749-7.749C418.409,189.853,414.939,186.384,410.66,186.384z",
    fill: "#0D2548"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.c5ac082f514ebf9a5398a32ce5565111.svg";
export { ForwardRef as ReactComponent };